import Vue from 'vue';
import VeeValidate, {Validator} from 'vee-validate';

const currentLocale = document.documentElement.lang;
(async () => {
    const messages = await (async () => {
        try {
            switch (currentLocale) {
                case 'de':
                    return await import(`vee-validate/dist/locale/de`);
                case 'nl':
                    return await import(`vee-validate/dist/locale/nl`);
                case 'es':
                    return await import(`vee-validate/dist/locale/es`);
                case 'fr':
                    return await import(`vee-validate/dist/locale/fr`);
                case 'en':
                default:
                    return await import(`vee-validate/dist/locale/en`);
            }
        } catch (e) {
            return await import(`vee-validate/dist/locale/en`);
        }
    })();
    Validator.localize(currentLocale, messages);
})();

Validator.extend('variant-rule-action', (action) => {
    return [
        action.fillColor, action.strokeColor,
        action.textColor, action.image
    ].some(v => !!v);
});

Validator.extend('is_regex', {
    getMessage: (field, params, data) => {
        return `Das ${field}s Feld ist kein valider Regulärer Ausdruck.`;
    },
    validate: value => {
        try {
            const result = (RegExp(value)).test('lel');
            return true;
        } catch (e) {
            return {
                valid: false,
                data: e
            };
        }
    },
});

Vue.use(VeeValidate);
